// tslint:disable:max-line-length
import { Component, OnChanges, OnInit, Input, EventEmitter, Output, AfterViewInit, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { MultiListBoxItem } from '../cpq-multi-list-box-with-selection/multi-list-box-item.model';
import { PermissionGroupCollection } from './cpq-permission-group-selection.model';
import { PermissionType } from '../../users-module/permission-groups-data-table/permission-group.model';
import { CpqMultiListBoxComponent } from '../cpq-multi-list-box/cpq-multi-list-box.component';
import { BlockedItems } from '../cpq-multi-list-box-with-selection/blocked-items.model';

@Component({
    selector: 'cpq-permission-groups-selection',
    templateUrl: './cpq-permission-groups-selection.component.html',
    standalone: false
})
export class CpqPermissionGroupsSelectionComponent implements OnChanges {
  @ViewChild('cpqMultiListBox') cpqMultiListBox: CpqMultiListBoxComponent;
  @Input('selectedPermissionGroups') selectedPermissionGroups: Array<MultiListBoxItem>;
  @Input('availablePermissionGroups') availablePermissionGroups: PermissionGroupCollection;
  @Input('skipPermissions') skipPermissions?: Array<PermissionType>;
  @Output('selectPermission') selectPermission = new EventEmitter<MultiListBoxItem>();
  @Output('removePermission') removePermission = new EventEmitter<MultiListBoxItem>();
  @Input('blockedItems') blockedItems: BlockedItems; 

  public available = new Array<MultiListBoxItem>();
  constructor() {
  }

  ngOnChanges() {
    if (this.availablePermissionGroups) {
      this.available = [];
      if (this.skipPermissions) {
        if (!this.skipPermissions.includes(PermissionType.Company)) {
          this.available.push(this.availablePermissionGroups.companyPermissions);
        }
        if (!this.skipPermissions.includes(PermissionType.ManualyCreated)) {
          this.available.push(this.availablePermissionGroups.manualPermissions);
        }
        if (!this.skipPermissions.includes(PermissionType.Multibranding)) {
          this.available.push(this.availablePermissionGroups.multiBrandingPermissions);
        }
        if (!this.skipPermissions.includes(PermissionType.Market) && this.availablePermissionGroups.marketPermissions) {
          this.available.push(this.availablePermissionGroups.marketPermissions);
        }
        if (!this.skipPermissions.includes(PermissionType.SalesOrganization) && this.availablePermissionGroups.salesOrgPermissions) {
          this.available.push(this.availablePermissionGroups.salesOrgPermissions);
        }
        if (!this.skipPermissions.includes(PermissionType.UserType)) {
          this.available.push(this.availablePermissionGroups.userTypePermissions);
        }
        if (!this.skipPermissions.includes(PermissionType.Users)) {
          this.available.push(this.availablePermissionGroups.users);
        }
      } else {
        this.available.push(this.availablePermissionGroups.companyPermissions);
        this.available.push(this.availablePermissionGroups.manualPermissions);
        this.available.push(this.availablePermissionGroups.multiBrandingPermissions);
        if (this.availablePermissionGroups.marketPermissions) {
          this.available.push(this.availablePermissionGroups.marketPermissions);
        }

        if (this.availablePermissionGroups.salesOrgPermissions) {
          this.available.push(this.availablePermissionGroups.salesOrgPermissions);
        }

        this.available.push(this.availablePermissionGroups.userTypePermissions);
        this.available.push(this.availablePermissionGroups.users);
      }
    }
  }

  onSelect($event: MultiListBoxItem) {
    this.selectPermission.next($event);
  }

  onRemove($event: MultiListBoxItem) {
    this.removePermission.next($event);
  }

}
